import { FiEdit, FiInfo, FiTrash2, FiSettings, FiPlay, FiX, FiZap } from "react-icons/fi";
import {
  scenarioExe,
  scenarioListWidget,
  scenarioWidgetExtraList,
} from "../../api";
import Cookies from "js-cookie";
import { useState } from "react";
import { Alert } from "../Alert";
import { AddScenario } from "./AddScenario";
import { ModalComp } from "../ModalComp";
import { useReducer } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const ScenariosModal = ({ scenario, closeModal }) => {
  const { t } = useTranslation();
  const { title, icon, uid } = scenario || {};
  const token = Cookies.get("token");
  const [openAddScenarioModal, setOpenAddScenarioModal] = useState(false);
  const [submitScenarioEdit, setSubmitScenarioEdit] = useState(false);
  const toggleAddScenario = () => {
    setOpenAddScenarioModal(!openAddScenarioModal);
    setSubmitScenarioEdit(!submitScenarioEdit);
  };
  const [scenarioCommand, setScenarioCommand] = useState([]);
  const [widgetIndex, setWidgetIndex] = useState("");
  
  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };
  
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
    question: false,
    request: "",
  });
  
  const handleScenarioExe = () => {
    var data = new FormData();
    data.append("scenario_id", uid);
    window.addEventListener("online", function () {
      setShowAlert({
        show: true,
        message: "you are connecting to the Internet",
        type: "Success",
      });
      setTimeout(() => {
        setShowAlert((prev) => ({ ...prev, show: false }));
      }, 5000);
    });
    window.addEventListener("offline", function () {
      setShowAlert({
        show: true,
        message: "Trying to connect...",
        type: "Error",
      });
      setTimeout(() => {
        setShowAlert((prev) => ({ ...prev, show: false }));
      }, 9000);
    });
    scenarioExe(data, token)
      .then((response) => {
        setShowAlert({
          show: true,
          message: t("سناریو با موفقیت اجرا شد."),
          type: "Success",
          request: "",
          question: "",
        });
        setTimeout(() => {
          setShowAlert((prev) => ({ ...prev, show: false }));
        }, 2000);
      })
      .catch((error) => {
        setShowAlert({
          show: true,
          message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
          type: "Error",
        });
        setTimeout(() => {
          setShowAlert((prev) => ({ ...prev, show: false }));
        }, 2000);
      });
  };
  
  const handleScenarioDelete = () => {
    setShowAlert({
      show: true,
      message: t("آیا از حذف سناریوی ") + t(`${title}`) + t(" اطمینان دارید؟"),
      type: "Warning",
      question: true,
      request: "deleteScenario",
    });
  };
  
  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    var formdata = new FormData();
    formdata.append("scenario_id", uid);
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    fetch("https://assessn.mmaviot.com/api/scenariowgapp_list", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let z = JSON.parse(result);
        if (z && z.data && Array.isArray(z.data)) {
          // فیلتر کردن آیتم‌های حذف شده
          // بررسی deleted_at و deleted
          const filteredData = z.data.filter(item => {
            // اگر deleted_at وجود دارد و مقدار آن null یا false نباشد، حذف شده است
            if (item.deleted_at) {
              // اگر deleted_at.Valid === true یعنی حذف شده
              if (item.deleted_at.Valid === true || item.deleted_at === true) {
                return false;
              }
            }
            // اگر deleted === true باشد، حذف شده
            if (item.deleted === true || item.deleted === "true") {
              return false;
            }
            // اگر deleted_at !== null باشد، حذف شده
            if (item.deleted_at !== null && item.deleted_at !== "null") {
              // بررسی بیشتر
              if (typeof item.deleted_at === 'object' && item.deleted_at.Valid === true) {
                return false;
              }
            }
            return true;
          });
          setScenarioCommand(filteredData);
        } else {
          setScenarioCommand([]);
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.status === 403) {
          setShowAlert({
            show: true,
            message: t(" خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          });
          setTimeout(() => {
            setShowAlert((prev) => ({ ...prev, show: false }));
          }, 2000);
        } else {
          console.log("Error fetching scenario commands:", error);
          setScenarioCommand([]);
        }
      });
  }, [uid, token, t]);

  const menuItems = [
    { icon: <FiPlay size={18} />, label: t("اجرا"), onClick: handleScenarioExe, color: "#00c853" },
    { icon: <FiEdit size={18} />, label: t("ویرایش"), onClick: toggleAddScenario, color: "#ff9800" },
    { icon: <FiTrash2 size={18} />, label: t("حذف"), onClick: handleScenarioDelete, color: "#f56565" },
  ];

  if (!scenario || !uid) {
    return null;
  }

  return (
    <>
      <ModalComp
        modal={openAddScenarioModal}
        toggle={toggleAddScenario}
        component={
          <AddScenario
            titleEdit={title}
            iconEdit={icon}
            uid={uid}
            submit={submitScenarioEdit}
            setOpenAddScenarioModal={setOpenAddScenarioModal}
            closeModal={closeModal}
            scenarioCommandEdit={scenarioCommand}
            setScenarioCommandEdit={setScenarioCommand}
          />
        }
      />
      
      <div className="scenario-modal-container">
        <div className="scenario-modal-header">
          <div className="scenario-modal-icon">
            <i className={`${icon}`}></i>
          </div>
          <div className="scenario-modal-info">
            <h3 className="scenario-modal-title">{t("سناریو")}</h3>
            <p className="scenario-modal-name">{title || "---"}</p>
          </div>
        </div>

        {menuItems && menuItems.length > 0 && (
          <div className="scenario-modal-menu">
            {menuItems.map((item, index) => (
              <div
                key={index}
                className="scenario-modal-menu-item"
                onClick={item.onClick}
              >
                <div className="scenario-modal-menu-icon" style={{ color: item.color }}>
                  {item.icon}
                </div>
                <span className="scenario-modal-menu-label">{item.label}</span>
              </div>
            ))}
          </div>
        )}

        {scenarioCommand && scenarioCommand.length > 0 && (
          <div className="scenario-modal-commands">
            <div className="scenario-modal-commands-header">
              <FiZap size={14} />
              <span>{t("رویدادهای سناریو")}</span>
            </div>
            <div className="scenario-modal-commands-list">
              {scenarioCommand.map((cmd, idx) => (
                <div key={idx} className="scenario-modal-command-item">
                  <span className="scenario-modal-command-name">
                    {cmd?.zone_widget_caption || cmd?.caption || "---"}
                  </span>
                  <span className={`scenario-modal-command-status ${cmd?.command === "10" ? "on" : "off"}`}>
                    {cmd?.command === "10" ? t("روشن") : t("خاموش")}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {showAlert.show && (
          <Alert
            message={showAlert.message}
            type={showAlert.type}
            question={showAlert.question}
            id={uid}
            toggleAlert={toggleAlert}
            request={showAlert.request}
            closeModal={closeModal}
            setOpenAddScenarioModal={setOpenAddScenarioModal}
            toggleAddScenario={toggleAddScenario}
          />
        )}
      </div>
    </>
  );
};

export { ScenariosModal };